import { ActivatedRouteSnapshot, Route } from '@angular/router';

import { AdvertisingGuard } from './core/auth/guards/advertising.guard';
import { AnalyticsService } from './modules/admin/dashboard/analytics.service';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { ExactRoleGuard } from './modules/auth/guards/ExactRoleGuard'; ///proteger les routes avec role exacte
import { FlashMemoryHomeComponent } from './modules/admin/mini-jeux/game-memory/flash-memory-home/flash-memory-home.component';
import { IncomingComponent } from './components/incoming/incoming.component';
import { LayoutComponent } from 'app/layout/layout.component';
import { NoAuthGuard } from './core/auth/guards/noAuth.guard';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ProjectService } from './modules/admin/statistiques/project.service';
import { RoleGuard } from './modules/auth/guards/role.guard'; //proteger les routesavec rout level et plus
import { SuperAdminAuthGuard } from './modules/super-admin/auth/super-admin-auth.guard';
import { TeamPublicViewComponent } from './modules/admin/team-public-view/team-public-view.component';
import { initialDataResolver } from 'app/app.resolvers';
import { inject } from '@angular/core';
import { WakeLockGuard } from './_guards/wake-lock.guard';

// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    // Redirect empty path to '/example'
    { path: '', pathMatch: 'full', redirectTo: 'journal' },

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'journal' },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                data: { hideBreadcrumb: true },
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                        ),
            },
            {
                path: 'forgot-password',
                title: 'Mot de passse oublié',
                data: { hideBreadcrumb: true },
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                        ),
            },
            {
                path: 'reset-password',
                title: 'Réinitialisation du mot de passe',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                        ),
            },
            {
                path: 'sign-in',
                title: 'Connexion',
                data: { hideBreadcrumb: true },
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
            {
                path: 'sign-up',
                title: 'Inscription',
                data: { hideBreadcrumb: true },
                loadChildren: () =>
                    import('app/modules/auth/sign-up/sign-up.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                title: 'Déconnexion',
                data: { hideBreadcrumb: true },
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            // {
            //     path: 'unlock-session',
            //     loadChildren: () =>
            //         import(
            //             'app/modules/auth/unlock-session/unlock-session.routes'
            //         ),
            // },
            {
                path: 'incoming',
                title: 'En travaux 🚧',
                component: IncomingComponent,
            },
            {
                path: 'not-found',
                title: 'Page introuvable',
                component: NotFoundComponent,
            },
            // { path: 'club', title: 'club', component: ClubComponent },
            /** Route accessible only to super admin for creating clubs */
            // { path: 'club', title: 'club', component: ClubComponent },
        ],
    },

    // Landing routes
    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/landing/home/home.routes'),
            },
        ],
    },

    /**
     * Super Admin routes
     */
    {
        path: 'super-admin',
        canActivate: [AuthGuard, SuperAdminAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'club',
                title: 'Gestion des clubs',
                loadComponent: () =>
                    import('app/modules/super-admin/club/club.component').then(
                        (c) => c.ClubComponent
                    ), // Chargement direct du composant autonome
            },
        ],
    },

    // Admin routes
    {
        //ici
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            // {
            //     path: 'example',
            //     loadChildren: () =>
            //         import('app/modules/admin/example/example.routes'),
            // },

            {
                // ? Pour les routes d'événements
                path: 'event',
                children: [
                    {
                        path: 'list/:id',
                        title: 'Liste des événements',
                        data: { breadcrumb: 'Événements' },
                        loadComponent: () =>
                            import(
                                './modules/admin/events/event-list/event-list.component'
                                ).then((c) => c.EventListComponent),
                    },
                    {
                        path: 'create/:categoryId',
                        title: 'Créer un événement',
                        data: { breadcrumb: 'Créer événement' },
                        loadComponent: () =>
                            import(
                                './modules/admin/events/event-create/event-create.component'
                                ).then((c) => c.EventCreateComponent),
                    },
                    {
                        path: 'edit/:categoryId/:eventId',
                        title: 'Modifier un événement',
                        data: {
                            breadcrumb: 'Modifier événement',
                            resolve: {
                                breadcrumb: (route: ActivatedRouteSnapshot) =>
                                    `Modifier événement ${route.params['eventId']}`,
                            },
                        },
                        loadComponent: () =>
                            import(
                                './modules/admin/events/event-create/event-create.component'
                                ).then((c) => c.EventCreateComponent),
                    },
                    {
                        path: 'detail/:categoryId/:eventId',
                        title: "Détails de l'événement",
                        data: {
                            breadcrumb: 'Détails événement',
                            resolve: {
                                breadcrumb: (route: ActivatedRouteSnapshot) =>
                                    `Événement ${route.params['eventId']}`,
                            },
                        },
                        loadComponent: () =>
                            import(
                                './modules/admin/events/event-detail/event-detail.component'
                                ).then((c) => c.EventDetailComponent),
                    },
                    {
                        path: 'live-match/:categoryId/:eventId',
                        title: 'Match en direct',
                        data: {
                            breadcrumb: 'Match en direct',
                            resolve: {
                                breadcrumb: (route: ActivatedRouteSnapshot) =>
                                    `Match en direct ${route.params['eventId']}`,
                            },
                        },
                        loadComponent: () =>
                            import(
                                './modules/admin/live-match/live-match.component'
                                ).then((c) => c.MatchLiveComponent),
                        canActivate: [WakeLockGuard], 
                        canDeactivate: [WakeLockGuard]         
                    },
                ],
            },

            {
                path: 'membres',
                children: [
                    {
                        path: 'list',
                        title: 'Liste des membres',
                        loadComponent: () =>
                            import(
                                './modules/admin/member/wrapper/wrapper.component'
                                ).then((c) => c.WrapperComponent),
                    },
                    {
                        path: 'add',
                        title: 'Ajouter des membres',
                        loadComponent: () =>
                            import(
                                './modules/admin/member/add-members/add-members.component'
                                ).then((c) => c.AddMembersComponent),
                    },
                    {
                        path: 'new',
                        title: 'Nouveau membre',
                        loadComponent: () =>
                            import(
                                './modules/admin/member/new-member/new-member.component'
                                ).then((c) => c.NewMemberComponent),
                    },
                    {
                        path: ':id/edit',
                        title: 'Modifier le membre',
                        loadComponent: () =>
                            import(
                                'app/modules/admin/member/member-edit/member-edit.component'
                                ).then((c) => c.MemberEditComponent),
                    },
                ],
            },
            {
                path: 'dashboard',
                loadChildren: () =>
                    import('app/modules/admin/dashboard/dashboard.routes'),
                // canActivate: [RoleGuard],
                // data: { level: 5000 },
            },

            // Pour les routes de photo-
            {
                path: 'photo-studio',
                data: { breadcrumb: 'Photo-Studio' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/photo-studio/photo-studio.component'
                        ).then((c) => c.PhotoStudioComponent),
                title: 'Photo Studio',
            },
            {
                path: 'upload-photo',
                title: 'Téléchargement de photos',
                data: { breadcrumb: 'Téléchargement' },
                loadComponent: () =>
                    import(
                        './modules/admin/photo-studio/upload-photo/upload-photo.component'
                        ).then((m) => m.UploadPhotoComponent),
            },
            {
                path: 'photo-editor',
                title: 'Éditeur de photos',
                data: { breadcrumb: 'Éditeur' },
                loadComponent: () =>
                    import(
                        './modules/admin/photo-studio/photo-editor/photo-editor.component'
                        ).then((m) => m.PhotoEditorComponent),
            },
            {
                path: 'photo-move',
                title: 'Ajustement de photos',
                data: { breadcrumb: 'Ajustement' },
                loadComponent: () =>
                    import(
                        './modules/admin/photo-studio/move-photo/move-photo.component'
                        ).then((m) => m.MovePhotoComponent),
            },
            {
                path: 'share-photo',
                title: 'Partage de la carte',
                data: { breadcrumb: 'Partage' },
                loadComponent: () =>
                    import(
                        './modules/admin/photo-studio/share-photo/share-photo.component'
                        ).then((m) => m.SharePhotoComponent),
            },
            /**
             * ? photo-studio routes
             */
            // ? {
            // ?     path: 'photo-studio',
            // ?     title: 'Studio photo',
            // ?     loadComponent: () =>
            // ?         import(
            // ?             './modules/admin/photo-studio/photo-studio.component'
            // ?         ).then((m) => m.PhotoStudioComponent),
            // ?     // ? canActivate: [ExactRoleGuard],
            // ?     // ? data: { level: 20000 }, // ?role exact
            // ? },
            // ? {
            // ?     path: 'upload-photo',
            // ?     title: 'Téléchargement de photos',
            // ?     loadComponent: () =>
            // ?         import(
            // ?             './modules/admin/photo-studio/upload-photo/upload-photo.component'
            // ?         ).then((m) => m.UploadPhotoComponent),

            // ?     // ? canActivate: [ExactRoleGuard],
            // ?     // ? data: { level: 20000 }, // ?role exact
            // ?     // ? canActivate: [
            // ?     // ?     () => {
            // ?     // ?         const router = inject(Router) as Router;
            // ?     // ?         if (!sessionStorage.getItem('fromPhotoStudio')) {
            // ?     // ?             router.navigate(['/photo-studio']);
            // ?     // ?             return false;
            // ?     // ?         }
            // ?     // ?         return true;
            // ?     // ?     },
            // ?     // ? ],
            // ? },
            // ? {
            // ?     path: 'photo-editor',
            // ?     title: 'Éditeur de photos',
            // ?     loadComponent: () =>
            // ?         import(
            // ?             './modules/admin/photo-studio/photo-editor/photo-editor.component'
            // ?         ).then((m) => m.PhotoEditorComponent),
            // ?     // ? canActivate: [ExactRoleGuard ],
            // ?     // ? data: { level: 20000 },// ?role exact
            // ?     // ? canActivate: [
            // ?     // ?     () => {
            // ?     // ?         const router = inject(Router) as Router;
            // ?     // ?         if (!sessionStorage.getItem('removeBackground')) {
            // ?     // ?             router.navigate(['/photo-studio']);
            // ?     // ?             return false;
            // ?     // ?         }
            // ?     // ?         return true;
            // ?     // ?     },
            // ?     // ? ],
            // ? },
            // ? {
            // ?     path: 'photo-move',
            // ?     title: 'Ajustement de photos',
            // ?     loadComponent: () =>
            // ?         import(
            // ?             './modules/admin/photo-studio/move-photo/move-photo.component'
            // ?         ).then((m) => m.MovePhotoComponent),
            // ?     // ? canActivate: [ExactRoleGuard ],
            // ?     // ? data: { level: 20000 },// ?role exact
            // ?     // ? canActivate: [
            // ?     // ?     () => {
            // ?     // ?         const router = inject(Router) as Router;
            // ?     // ?         if (!sessionStorage.getItem('MovePhotoComponent')) {
            // ?     // ?             router.navigate(['/photo-studio']);
            // ?     // ?             return false;
            // ?     // ?         }
            // ?     // ?         return true;
            // ?     // ?     },
            // ?     // ? ],
            // ? },

            // ? {
            // ?     path: 'share-photo',
            // ?     title: 'Partage de la carte',
            // ?     loadComponent: () =>
            // ?         import(
            // ?             './modules/admin/photo-studio/share-photo/share-photo.component'
            // ?         ).then((m) => m.SharePhotoComponent),

            // ?     // ? canActivate: [ExactRoleGuard ],
            // ?     // ? data: { level: 20000 }, // ?role exact
            // ?     // ? canActivate: [
            // ?     // ?     () => {
            // ?     // ?         const router = inject(Router) as Router;
            // ?     // ?         if (!sessionStorage.getItem('editedPhoto')) {
            // ?     // ?             router.navigate(['/photo-studio']);
            // ?     // ?             return false;
            // ?     // ?         }
            // ?     // ?         return true;
            // ?     // ?     },
            // ?     // ? ],
            // ? },

            {
                path: 'calendrier',
                title: 'Calendrier',
                data: { breadcrumb: 'Calendrier' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/calendrier/calendrier.component'
                        ).then((c) => c.CalendrierComponent),
            },

            {
                path: 'classement',
                title: 'Le classement',
                loadComponent: () =>
                    import(
                        'app/modules/admin/classement/classement.component'
                        ).then((c) => c.ClassementComponent),
                // component: ClassementComponent,
                resolve: {
                    data: () => inject(ProjectService).getData(),
                },
            },
            {
                path: 'messagerie',
                title: 'Messagerie',
                data: { breadcrumb: 'Messagerie' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/messagerie/messagerie.component'
                        ).then((c) => c.MessagerieComponent),
            },

            // {
            //     path: 'effectif',
            //     title: 'Effectif',
            //     data: { breadcrumb: 'Effectif' },
            //     loadComponent: () =>
            //         import(
            //             'app/modules/admin/effectif/effectif.component'
            //         ).then((c) => c.EffectifComponent),
            // },
            // {
            //     path: 'player',
            //     title: 'Joueur',
            //     data: { breadcrumb: 'Joueur' },
            //     loadComponent: () =>
            //         import(
            //             'app/modules/admin/effectif/player/player.component'
            //         ).then((c) => c.PlayerComponent),
            // },
            // {
            //     path: 'effectif/player/player-details/:id',
            //     title: 'Profil du joueur',
            //     loadComponent: () =>
            //         import(
            //             'app/modules/admin/effectif/player-details/player-details.component'
            //         ).then((c) => c.PlayerDetailsComponent),
            //     resolve: {
            //         data: () => inject(AnalyticsService).getData(),
            //     },
            // },
            {
                path: 'profil',
                title: 'Mon profil',
                loadChildren: () =>
                    import('app/modules/admin/profile/profile.routes'),
            },
            {
                path: 'journal',
                title: "Mon fil d'actualité",
                loadComponent: () =>
                    import('app/modules/admin/journal/journal.component').then(
                        (c) => c.JournalComponent
                    ),
            },
            {
                path: 'parametre',
                title: 'Paramètres',
                loadChildren: () =>
                    import('app/modules/admin/parametre/parametre.routes'),
            },
            {
                path: 'sponsoring',
                title: 'Sponsoring',
                data: { breadcrumb: 'Sponsoring' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/sponsoring/sponsoring.component'
                        ).then((c) => c.SponsoringComponent),
            },
            {
                path: 'dashboard-partenaires',
                title: 'Gestions des partenaires',
                data: { breadcrumb: 'Gestion partenaires' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/sponsoring/admin-partners-dashboard/admin-partners-dashboard.component'
                        ).then((c) => c.AdminPartnersDashboardComponent),
            },
            {
                path: 'partenaire',
                title: 'Les bienfaiteurs',

                loadComponent: () =>
                    import(
                        'app/components/partenaire/partenaire.component'
                        ).then((c) => c.PartenaireComponent),
            },
            {
                path: 'partenaire-detail/:id',
                title: 'Détail partenaire',
                loadComponent: () =>
                    import(
                        'app/components/partenaire/partenaire-details/partenaire-details.component'
                        ).then((c) => c.PartenaireDetailsComponent),
                resolve: {
                    data: () => inject(AnalyticsService).getData(),
                },
            },
            {
                path: 'active-announcement/:id',
                loadComponent: () =>
                    import(
                        'app/components/active-announcement-by-id/active-announcement-by-id.component'
                        ).then((m) => m.ActiveAnnouncementByIdComponent),
            },
              {
                path: 'pub-parrain/:id',
                loadComponent: () =>
                    import(
                        'app/components/pub-parrain/pub-parrain.component'
                        ).then((m) => m.pubParrainComponent),
            },
            // Pour les mini-jeux
            {
                path: 'mini-jeux',
                title: 'Les Mini-jeux',
                data: { breadcrumb: 'Mini-jeux' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/mini-jeux/mini-jeux.component'
                        ).then((c) => c.MiniJeuxComponent),
            },
            {
                path: 'nombre-mystere-home',
                title: 'NOMBRE MYSTÈRE home',
                data: {
                    layout: 'empty',
                    breadcrumb: 'Nombre mystère',
                    hideBreadcrumb: false,
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/mini-jeux/mystere/nombreMystereHome/nombreMystereHome.component'
                        ).then((c) => c.NombreMystereHomeComponent),
            },
            {
                path: 'nombre-mystere',
                title: 'NOMBRE MYSTÈRE',
                data: {
                    layout: 'empty',
                    breadcrumb: 'Jeu nombre mystère',
                    hideBreadcrumb: false,
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/mini-jeux/mystere/nombreMyster.component'
                        ).then((c) => c.NombreMysterComponent),
            },
            {
                path: 'flash-memory-home',
                title: 'Règles du jeu',
                data: {
                    layout: 'empty',
                    breadcrumb: 'Règles Flash Memory',
                    hideBreadcrumb: false,
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/mini-jeux/game-memory/flash-memory-home/flash-memory-home.component'
                        ).then((c) => c.FlashMemoryHomeComponent),
            },
            {
                path: 'flash-memory',
                title: 'Flash Memory',
                data: {
                    layout: 'empty',
                    breadcrumb: 'Jeu Flash Memory',
                    hideBreadcrumb: false,
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/mini-jeux/game-memory/game-memory.component'
                        ).then((c) => c.GameMemoryComponent),
            },
            {
                path: 'product/:id',
                title: 'Bon plan',
                data: {
                    breadcrumb: 'Bon plan',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Bon plan ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import('app/modules/admin/product/product.component').then(
                        (c) => c.ProductComponent
                    ),
            },
            {
                path: 'gift-products',
                title: 'Lots à gagner',
                loadChildren: () =>
                    import('app/modules/admin/ecommerce/ecommerce.routes'),
            },
            {
                path: 'products',
                title: 'Lots à venir',
                data: { breadcrumb: 'Lots à venir' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/products/products.component'
                        ).then((c) => c.ProductsComponent),
            },
            {
                path: 'statistiques',
                title: 'Mes statistiques',
                data: { breadcrumb: 'Statistiques' },
                resolve: {
                    data: () => inject(ProjectService).getData(),
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/statistiques/statistiques.component'
                        ).then((c) => c.StatistiquesComponent),
            },
            {
                path: 'evenements',
                title: 'Mon calendrier',
                data: { breadcrumb: 'Événements' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/activities/activities.component'
                        ).then((c) => c.ActivitiesComponent),
            },
            {
                path: 'organigramme',
                title: 'Organigramme du club',
                loadComponent: () =>
                    import(
                        'app/components/organigramme/organigramme.component'
                        ).then((c) => c.OrganigrammeComponent),
            },
            {
                path: 'cagnotte',
                title: 'Cagnotte du club',
                loadChildren: () =>
                    import('app/modules/admin/cagnotte/cagnotte.routes'),
            },
            {
                path: 'points',
                title: 'Mes points',
                data: { breadcrumb: 'Mes points' },
                loadComponent: () =>
                    import(
                        'app/components/mes-points/mes-points.component'
                        ).then((c) => c.MesPointsComponent),
            },
            {
                path: 'espace-exclusif-parrain',
                title: 'Espace parrain exclusif',
                data: { breadcrumb: 'Espace parrain' },
                loadComponent: () =>
                    import(
                        'app/components/espace-exclusif-parrain/espace-exclusif-parrain.component'
                        ).then((c) => c.EspaceExclusifParrainComponent),
            },
            {
                path: 'espace-parrain',
                title: 'Espace parrain',
                loadComponent: () =>
                    import(
                        'app/components/espace-parrain/espace-parrain.component'
                        ).then((c) => c.EspaceParrainComponent),
            },
            {
                path: 'annonces/:id',
                loadComponent: () =>
                    import(
                        './components/espace-exclusif-parrain/admin-annonce-detail/admin-annonce-detail.component'
                        ).then((m) => m.AdminAnnonceDetailComponent),
            },
            {
                path: 'category',
                title: 'Catégorie',
                loadComponent: () =>
                    import(
                        'app/modules/admin/category/category/category.component'
                        ).then((c) => c.CategoryComponent),
                // ici la methode de levels pour gestion des roles
                // canActivate: [RoleGuard],
                // data: { level: 100000 }, //COACH
            },
            {
                path: 'category-view/:id',
                title: 'Vue de la catégorie',
                data: {
                    breadcrumb: 'Vue catégorie',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Catégorie ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/category/category-view/category-view.component'
                        ).then((c) => c.CategoryViewComponent),
                // ici la methode de levels pour gestion des roles
                // canActivate: [RoleGuard],
                // data: { level: 100000 }, //COACH
            },
            {
                path: 'teams/:id/public',
                component: TeamPublicViewComponent,
                data: {
                    title: "Vue publique de l'équipe",
                    breadcrumb: 'Vue publique équipe',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Équipe publique ${route.params['id']}`,
                    },
                },
            },
            {
                path: 'team/:id',
                title: "Membres de l'équipe",
                loadComponent: () =>
                    import(
                        'app/modules/admin/teams/team-members-list/team-members-list.component'
                        ).then((c) => c.TeamMembersListComponent),
            },
            {
                path: 'event/:eventId/line-up',
                title: 'Composition',
                data: {
                    breadcrumb: 'Composition',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Composition événement ${route.params['eventId']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        './modules/admin/lineup/line-up-config.component'
                        ).then((c) => c.LineUpConfigComponent),
            },
            {
                path: 'categories/:id',
                title: 'Détails de la catégorie',
                loadComponent: () =>
                    import(
                        'app/modules/admin/category/category-details/category-details.component'
                        ).then((c) => c.CategoryDetailsComponent),
            },
            {
                path: 'presence-synthesis',
                title: 'Synthèse des présences',
                data: { breadcrumb: 'Synthèse présences' },
                loadComponent: () =>
                    import(
                        'app/components/presences/presence-header/presence-header.component'
                        ).then((c) => c.PresenceHeaderComponent),
            },
            {
                path: 'player-profile',
                title: 'Profil du joueur',
                data: {
                    breadcrumb: 'Profil joueur',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Profil ${route.params['playerId']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/profile/player-profile/player-profile.component'
                        ).then((c) => c.PlayerProfileComponent),
            },
            {
                path: 'player-profile/:playerId',
                title: 'Profil du joueur',
                loadComponent: () =>
                    import(
                        'app/modules/admin/profile/player-profile/player-profile.component'
                        ).then((c) => c.PlayerProfileComponent),
            },
            {
                path: 'taches',
                title: 'Tâches',
                data: { breadcrumb: 'Tâches' },
                loadComponent: () =>
                    import(
                        'app/components/taches/taches/taches.component'
                        ).then((c) => c.TachesComponent),
            },
            {
                path: 'stats',
                title: 'Statistiques',
                data: { breadcrumb: 'Stats' },
                loadComponent: () =>
                    import('app/components/stats/stats.component').then(
                        (c) => c.StatsComponent
                    ),
            },
            {
                path: 'forum',
                title: 'Forum',
                data: { breadcrumb: 'Forum' },
                loadComponent: () =>
                    import('app/components/forum/forum.component').then(
                        (c) => c.ForumComponent
                    ),
            },
            {
                path: 'point-classement',
                title: 'Classement aux points',
                data: { breadcrumb: 'Points classement' },
                loadComponent: () =>
                    import(
                        'app/components/parametres-classement/pointsdeclassement.component'
                        ).then((c) => c.PointsdeclassementComponent),
            },
            {
                path: 'statistique-equipe',
                title: "Statistiques de l'équipe",
                data: { breadcrumb: 'Stats équipe' },
                loadComponent: () =>
                    import(
                        'app/components/statistique/statistique/statistique.component'
                        ).then((c) => c.StatistiqueComponent),
            },
            {
                path: 'team/view/:id',
                title: "Vue de l'équipe",
                data: {
                    breadcrumb: 'Vue équipe',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Équipe ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/teams/team-view/team-view.component'
                        ).then((c) => c.TeamViewComponent),
            },
            {
                path: 'complet',
                data: { breadcrumb: 'Statistiques complètes' },
                children: [
                    {
                        path: '',
                        data: { breadcrumb: 'Vue générale' },
                        loadComponent: () =>
                            import(
                                'app/components/complet/complet.component'
                                ).then((c) => c.CompletComponent),
                    },
                    {
                        path: 'player-table',
                        title: 'Détails',
                        data: { breadcrumb: 'Détails joueurs' },
                        loadComponent: () =>
                            import(
                                'app/components/player-table/player-table.component'
                                ).then((c) => c.PlayerTableComponent),
                    },
                    {
                        path: 'buts',
                        title: 'Buts',
                        data: { breadcrumb: 'Buts' },
                        loadComponent: () =>
                            import('app/components/buts/buts.component').then(
                                (c) => c.ButsComponent
                            ),
                    },
                    {
                        path: 'cartons',
                        title: 'Cartons',
                        data: { breadcrumb: 'Cartons' },
                        loadComponent: () =>
                            import(
                                'app/components/cartons/cartons.component'
                                ).then((c) => c.CartonsComponent),
                    },
                    {
                        path: 'passes',
                        title: 'Passes',
                        data: { breadcrumb: 'Passes' },
                        loadComponent: () =>
                            import(
                                'app/components/passes/passes.component'
                                ).then((c) => c.PassesComponent),
                    },
                    {
                        path: 'hdm',
                        title: 'Homme du match',
                        data: { breadcrumb: 'Homme du match' },
                        loadComponent: () =>
                            import('app/components/hdm/hdm.component').then(
                                (c) => c.HdmComponent
                            ),
                    },
                    {
                        path: 'participation',
                        title: 'Participations',
                        data: { breadcrumb: 'Participations' },
                        loadComponent: () =>
                            import(
                                'app/components/participation/participation.component'
                                ).then((c) => c.ParticipationComponent),
                    },
                    {
                        path: 'notes',
                        title: 'Notes',
                        data: { breadcrumb: 'Notes' },
                        loadComponent: () =>
                            import('app/components/notes/notes.component').then(
                                (c) => c.NotesComponent
                            ),
                    },
                    { path: '**', redirectTo: 'not-found' },
                ],
            },
            {
                path: 'indisponibilites',
                title: 'Gestion des indisponibilités',
                data: { breadcrumb: 'Indisponibilités' },
                loadComponent: () =>
                    import('app/components/profil/profil.component').then(
                        (c) => c.ProfilComponent
                    ),
            },
            {
                path: 'packs',
                title: 'Mes packs',
                data: { breadcrumb: 'Mes packs' },
                loadComponent: () =>
                    import(
                        'app/components/pack/list-pack/list-pack.component'
                        ).then((c) => c.ListPackComponent),
            },
            {
                path: 'infrastructure-dashboard',
                title: 'Infrastructures',
                data: { breadcrumb: 'Infrastructures' },
                loadComponent: () =>
                    import(
                        'app/components/infrastructure-dashboard/infrastructure-dashboard.component'
                        ).then((c) => c.InfrastructureDashboardComponent),
            },
            {
                path: 'infrastructure/:id',
                title: 'Infrastructure en détail',
                data: {
                    breadcrumb: 'Détail infrastructure',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Infrastructure ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/components/infrastructure-detail/infrastructure-detail.component'
                        ).then((c) => c.InfrastructureDetailComponent),
            },
            {
                path: 'opponents',
                title: 'Adversaires',
                data: { breadcrumb: 'Adversaires' },
                loadComponent: () =>
                    import(
                        'app/components/opponent-dashboard/opponent-dashboard.component'
                        ).then((c) => c.OpponentDashboardComponent),
            },
            {
                path: 'opponents/:id',
                title: "Détails de l'adversaire",
                data: {
                    breadcrumb: 'Détail adversaire',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Adversaire ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/components/opponent-detail/opponent-detail.component'
                        ).then((c) => c.OpponentDetailComponent),
            },
            {
                path: 'payments',
                title: 'Mes paiements',
                data: { breadcrumb: 'Paiements' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/payments/payments.component'
                        ).then((c) => c.PaymentsComponent),
            },
            {
                path: 'discount-management',
                title: 'Gestion des réductions',
                data: { breadcrumb: 'Gestion réductions' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/payments/discount-management/discount-management.component'
                        ).then((c) => c.DiscountManagementComponent),
            },
            {
                path: 'championship-day',
                title: 'Journée de championnat',
                data: { breadcrumb: 'Journée championnat' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/championship-day/championship-day.component'
                        ).then((c) => c.ChampionshipDayComponent),
            },
            {
                path: 'championship-create/:id',
                title: 'Création de championnat',
                data: {
                    breadcrumb: 'Créer championnat',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Créer championnat ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/championship-day/championship-create/championship-create.component'
                        ).then((c) => c.ChampionshipCreateComponent),
            },
            {
                path: 'advertising-campaign',
                title: 'Campagne publicitaire',
                data: { breadcrumb: 'Paiement pub' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/sponsoring/wrapper-sponsoring/wrapper-sponsoring.component'
                        ).then((c) => c.WrapperSponsoringComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'advertising-payment',
                title: 'Campagne publicitaire payment',
                data: { breadcrumb: 'Campagne pub' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/advertising-campaign/payment-advertising/payment-advertising.component'
                        ).then((c) => c.PaymentAdvertisingComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'advertising-campaign/:id',
                title: 'Détails de la campagne publicitaire',
                data: {
                    breadcrumb: 'Détails campagne',
                    resolve: {
                        breadcrumb: (route: ActivatedRouteSnapshot) =>
                            `Campagne ${route.params['id']}`,
                    },
                },
                loadComponent: () =>
                    import(
                        'app/modules/admin/advertising-campaign/advertising-campaign-detail/advertising-campaign-detail.component'
                        ).then((c) => c.AdvertisingCampaignDetailComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'advertising-campaign-form',
                title: 'Formulaire de campagne publicitaire',
                data: { breadcrumb: 'Formulaire campagne' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/advertising-campaign/advertising-campaign-form/advertising-campaign-form.component'
                        ).then((c) => c.AdvertisingCampaignFromComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'advertising-campaign-payment',
                title: 'Paiement de la campagne publicitaire',
                data: { breadcrumb: 'Paiement campagne' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/advertising-campaign/advertising-campaign-payment-summary/advertising-campaign-payment-summary.component'
                        ).then((c) => c.AdvertisingCampaignPaymentSummaryComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'advertising-campaign-stats',
                title: 'Statistiques de la campagne publicitaire',
                data: { breadcrumb: 'Stats campagne' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/advertising-campaign/advertising-stats/advertising-stats.component'
                        ).then((c) => c.AdvertisingStatsComponent),

                canActivate: [AdvertisingGuard],
            },
            {
                path: 'championship',
                title: 'Championnat',
                data: { breadcrumb: 'Championnat' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/championship/championship.component'
                        ).then((c) => c.ChampionshipComponent),
            },
            {
                path: 'club-story',
                title: 'Histoire du Club',
                data: { breadcrumb: 'Histoire du club' },
                loadComponent: () =>
                    import(
                        'app/modules/admin/club-story/club-story.component'
                        ).then((c) => c.ClubStoryComponent),
            },
            {
                path: 'match-calendar',
                title: 'Calendrier des matchs',
                loadComponent: () =>
                    import(
                        './modules/admin/match-calendar/match-calendar.component'
                        ).then((c) => c.MatchCalendarComponent),
                // Temporarily remove AuthGuard for development
                // canActivate: [AuthGuard],
                // canActivateChild: [AuthGuard],
            },
            {
                path: 'match-score',
                title: 'Final Score',
                loadComponent: () =>
                    import(
                        './modules/admin/match-score/match-score.component'
                        ).then((c) => c.MatchScoreComponent),
            },
            {
                path: 'match-score/:id',
                title: 'Score du match',
                loadComponent: () =>
                    import(
                        './modules/admin/match-score/match-score.component'
                        ).then((c) => c.MatchScoreComponent),
            },
            {
                path: 'live-matches',
                title: 'Matchs en direct',
                loadComponent: () =>
                    import(
                        './modules/admin/match-calendar/live-matches/live-matches.component'
                        ).then((c) => c.LiveMatchesComponent),
            },
            {
                path: 'match-details',
                title: 'Détails du match',
                loadComponent: () =>
                    import(
                        './modules/admin/match-calendar/match-details/match-details.component'
                        ).then((c) => c.MatchDetailsComponent),
            },
                {
                path: 'match-timeline/:id',
                title: 'match-timeline',
                loadComponent: () =>
                    import(
                        './components/matchLive/match-timeline/match-timeline.component'
                    ).then((c) => c.MatchTimelineComponent),
            },
        ],
    },

    { path: '**', redirectTo: 'not-found' },
];
